import isProd from './is-production.js';
export default (string, fallback) => {
    try {
        return JSON.parse(string);
    }
    catch (err) {
        if (!isProd())
            console.error('WARNING:', err.message, string);
        return fallback;
    }
};
//# sourceMappingURL=parse-json.js.map